import React, { useState, useEffect } from 'react';
import { Menu } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { data, isRTL } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById('hero');
      if (heroSection) {
        const heroHeight = heroSection.offsetHeight;
        const isScrolled = window.scrollY >= (heroHeight - 80);
        if (isScrolled !== scrolled) {
          setScrolled(isScrolled);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Get active sections for navigation
  const getNavigationItems = () => {
    const items = [];
    
    if (data.slideshow.active) {
      items.push({ id: 'hero', title: data.slideshow.title });
    }
    if (data.ourservice.active) {
      items.push({ id: 'services', title: data.ourservice.title });
    }
    if (data.ourprojects.active) {
      items.push({ id: 'projects', title: data.ourprojects.title });
    }
    if (data.technews.active) {
      items.push({ id: 'technews', title: data.technews.title });
    }
    if (data.ourclients.active) {
      items.push({ id: 'clients', title: data.ourclients.title });
    }
    if (data.founder?.active) {
      items.push({ id: 'founder', title: data.founder.title });
    }
    if (data.contactus.active) {
      items.push({ id: 'contact', title: data.contactus.title });
    }
    
    return items;
  };

  const navItems = getNavigationItems();

  return (
    <nav className={`fixed w-full z-50 ${scrolled ? 'scrolled' : ''}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img 
              src={data.site_settings.logo} 
              alt={data.site_settings.site_name}
              className="h-10 w-auto"
              onError={(e) => {
                // Fallback to text logo if image fails to load
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling.style.display = 'block';
              }}
            />
            <div 
              className={`text-2xl font-bold ${scrolled ? 'text-white' : 'text-white'} hidden`}
              style={{ display: 'none' }}
            >
              {data.site_settings.site_name}
            </div>
          </div>
          
          <div className={`hidden md:flex items-center ${isRTL ? 'space-x-reverse space-x-8' : 'space-x-8'}`}>
            {navItems.map((item) => (
              <button 
                key={item.id}
                onClick={() => scrollToSection(item.id)} 
                className="hover:text-blue-400 text-white transition-colors duration-200"
              >
                {item.title}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <LanguageToggle />
            <button className="md:hidden text-white">
              <Menu size={24} />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}